<template>
  <div class="permission-action-toggle uk-card uk-card-default uk-card-body uk-margin-small">
    <label>
      <input :checked="permission.enabled" class="uk-checkbox" type="checkbox"
             @change="updatePermission({ enabled: $event.target.checked })"
      >
      <strong>{{ permission.name }}</strong>
    </label>

    <div class="d-flex">
      <div v-for="(action, actionIndex) in permission.actions" :key="actionIndex">
        <label>{{ action.name }}</label>
        <label class="uk-switch">
          <input
              :checked="action.enabled"
              :disabled="!permission.enabled"
              type="checkbox"
              @change="updatePermission({ index: actionIndex, enabled: $event.target.checked })"
          />
          <div class="uk-switch-slider"></div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    permission: {
      type: Object,
      required: true
    }
  },
  methods:{
    updatePermission({ enabled, actionIndex }) {

      const updatedPermission = { ...this.permission };
      if (actionIndex !== undefined) {
        updatedPermission.actions[actionIndex].enabled = enabled;
      } else {
        updatedPermission.enabled = enabled;
      }

      this.$emit('update:permission', updatedPermission);
    }

  }
};
</script>
